import { orderConfirmationShippingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(orderConfirmationShippingInformationStyles, {
    shippingInformationCarrierGridItem: {
        css: css`
            display: none;
        `,
    },
    shippingInformationServiceGridItem: {
        css: css`
            display: none;
        `,
    },
});
